import { useEffect, useState, lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import Loader from './common/Loader';
import PageTitle from './components/PageTitle';
import { SignIn } from './pages/Authentication/SignIn';
import routes from './routes';
import { useUser } from './utils/use-user';
import 'react-toastify/dist/ReactToastify.css';
const DefaultLayout = lazy(() => import('./layout/DefaultLayout'));
const ProtectedRoute = ({ children }) => {
  const [user] = useUser();
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};
function App() {
  const [loading, setLoading] = useState<boolean>(true);
  const [user, setUser] = useUser();

  useEffect(() => {
  const handleStorageChange = async (e: StorageEvent) => {
    if (e.key === 'selectedBackend' && localStorage.getItem('bearer')) {
      localStorage.removeItem('bearer');
      window.location.href = '/login';
    }
  };
    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  useEffect(() => {
    setTimeout(() => setLoading(false), 1000);
  }, [user]);

  return loading ? (
    <Loader />
  ) : (
    <>
      <Routes>
        <Route
          path="/login"
          element={
            <>
              <PageTitle title="Signin" />
              <SignIn />
            </>
          }
        />

        <Route element={<DefaultLayout />}>
          {routes.map(({ path, component: Component }, index) => (
            <Route
              key={index}
              path={path}
              element={
                <ProtectedRoute>
                  <Suspense fallback={<Loader />}>
                    <Component />
                    <ToastContainer autoClose={1000} />
                  </Suspense>
                </ProtectedRoute>
              }
            />
          ))}
        </Route>
      </Routes>
    </>
  );
}

export default App;
